// src/components/_v3/touristic-site/SiteFooter.jsx
import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {Wrap} from '../../../_ui/_v3/primitives';
import logo from 'assets/img/logo/Logo_henri-side.svg';

const FooterStyled = styled.footer`
  /* le SCSS global (_template.scss) fixe tout <footer> en position:fixed bottom — on neutralise */
  position: static;
  z-index: auto;
  background: ${props => props.theme.colors.paperCard};
  border-top: 1px solid ${props => props.theme.colors.line};
  margin-top: 1rem;
`;

const FooterTopStyled = styled(Wrap)`
  padding-block: 2.4rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1.6rem 2rem;
`;

const BrandStyled = styled.div`
  img { height: 26px; width: auto; }
  p {
    max-width: 32ch;
    font-size: .85rem;
    color: ${props => props.theme.colors.inkSoft};
  }
`;

const LinksStyled = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: .5rem 1.6rem;
  a {
    text-decoration: none;
    color: ${props => props.theme.colors.inkSoft};
    font-size: .87rem;
    font-weight: 600;
  }
  a:hover { color: ${props => props.theme.colors.ink}; }
`;

const FooterBottomStyled = styled(Wrap)`
  border-top: 1px solid ${props => props.theme.colors.line};
  padding-block: 1.1rem;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: .76rem;
  color: ${props => props.theme.colors.inkFaint};
`;

const SiteFooter = () => {
  const {t} = useTranslation(['touristic-site']);
  return (
    <FooterStyled>
      <FooterTopStyled>
        <BrandStyled>
          <img src={logo} alt="Henri Trip" />
          <p>{t('v3.footer.baseline')}</p>
        </BrandStyled>
        <LinksStyled>
          <a href="https://www.henritrip.fr/app-mobile">{t('v3.header.app')}</a>
          <a href="https://www.henritrip.fr/henri-trip">{t('v3.header.about')}</a>
          <a href="https://www.henritrip.fr/outils-voyage">{t('v3.header.tools')}</a>
          <a href="https://www.henritrip.fr/abonnement-henri-trip">{t('v3.header.subscribe')}</a>
        </LinksStyled>
      </FooterTopStyled>
      <FooterBottomStyled>
        <span>{t('v3.footer.copyright')}</span>
        <span>{t('v3.footer.data_sources')}</span>
      </FooterBottomStyled>
    </FooterStyled>
  );
};

export default SiteFooter;
